import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";
import AdministrativeAttachmentsTable, {
    AdministrativeAttachmentTableProps
} from "../../../pages/program/administrative/components/AdministrativeAttachmentsTable";


interface OwnProps extends SlideOverProps, AdministrativeAttachmentTableProps {}

type Props = OwnProps;

// @ts-ignore
const AdministrativeAttachmentsTableModal = NiceModal.create<Props>(({onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <AdministrativeAttachmentsTable {...rest}/>
        </SlideOver>
    )
})

export default AdministrativeAttachmentsTableModal;
